// @ts-nocheck

import PropTypes from 'prop-types';
import { CheckCircle } from '@phosphor-icons/react';
import './RefundMessage.css';

const RefundMessage = ({ id, title, description }) => {
  return (
    <div className='refund-message' id={id}>
      <CheckCircle size={40} className='refund-message__icon' />
      {title && <span className='refund-message__title'>{title}</span>}
      {description && (
        <span className='refund-message__description'>{description}</span>
      )}
    </div>
  );
};

RefundMessage.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
};

export default RefundMessage;
